/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import type { CustomerDetailsAppLayout as ServicedeskCustomerDetailsType } from '@jira/spa-apps__servicedesk-customer-details/src/CustomerDetailsAppLayout.tsx';
import type { ContactsAppLayout as ServicedeskContactsType } from '@jira/spa-apps__servicedesk-contacts/src/ContactsAppLayout.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyContactsAppLayout: LazyComponent<React.FC<{}>> = lazyForPaint<
	typeof ServicedeskContactsType
>(
	() =>
		import(
			/* webpackChunkName: "async-servicedesk-contacts", jiraSpaEntry: "async-servicedesk-contacts" */ '@jira/spa-apps__servicedesk-contacts/src/ServicedeskContacts.tsx'
		),
);

export const LazyServicedeskCustomerDetails: LazyComponent<React.FC<{}>> = lazyForPaint<
	typeof ServicedeskCustomerDetailsType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-servicedesk-customer-details", jiraSpaEntry: "async-servicedesk-customer-details" */ '@jira/spa-apps__servicedesk-customer-details/src/ServicedeskCustomerDetails.tsx'
		),
	),
);

export const ServicedeskCustomerDetails = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskCustomerDetails}
		pageId="spa-apps/servicedesk/customer-details"
		shouldShowSpinner
	/>
);

export const ServiceDeskContacts = (): React.JSX.Element => (
	<LazyPage Page={LazyContactsAppLayout} pageId="spa-apps/servicedesk/contacts" shouldShowSpinner />
);
